import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { fmtDate } from "@/lib/api";

const Body = ({ n }) => (
  <>
    <div className="h-44 bg-slate-100 overflow-hidden relative">
      <img src={n.foto ? `${process.env.REACT_APP_BACKEND_URL}${n.foto}` : "/news-default.jpg"} alt={n.titolo} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <div className="text-xs font-mono-x uppercase tracking-wider text-muted-foreground" data-testid={`news-card-date-${n.id}`}>{fmtDate(n.data)}</div>
      <h3 className="font-heading text-xl uppercase leading-tight mt-1 text-[#0B192C]">{n.titolo}</h3>
      {n.estratto && <p className="text-sm text-slate-600 mt-2 line-clamp-3">{n.estratto}</p>}
      <span className="mt-auto pt-4 text-sm text-emerald-700 font-medium inline-flex items-center gap-1">
        Leggi la notizia completa {n.interna ? <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /> : <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />}
      </span>
    </div>
  </>
);

const CLS = "fade-up group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow] duration-200 flex flex-col";

export const NewsCard = ({ n, delay = 0, publicBase }) =>
  n.interna ? (
    <Link to={publicBase ? `${publicBase}/${n.id}` : `/notizie/${n.id}`} style={{ animationDelay: `${delay}ms` }} className={CLS} data-testid={`news-card-${n.id}`}><Body n={n} /></Link>
  ) : (
    <a href={n.link} target="_blank" rel="noreferrer" style={{ animationDelay: `${delay}ms` }} className={CLS} data-testid={`news-card-${n.id}`}><Body n={n} /></a>
  );
